import { Icon } from "semantic-ui-react";

import type { Assign, OpenAPI } from "simplydo/interfaces";

import IdeaPdfExport from "components/lib/IdeaPdfExport";
import { TooltipButton } from "components/lib/UI";

type DownloadPDFActionProps = {
  idea: Assign<
    OpenAPI.Schemas["Idea"],
    OpenAPI.Schemas["AssignIdeaChallenges"]
  >;
};

const DownloadPDFAction = ({ idea }: DownloadPDFActionProps) => {
  return (
    <IdeaPdfExport
      ideas={[idea]}
      challenge={idea?.ownerChallenge}
      popupOffset={[0, -7]}
      hidePopup
      trigger={
        <TooltipButton icon tooltip="Download PDF">
          <Icon name="file pdf" />
        </TooltipButton>
      }
    />
  );
};

export default DownloadPDFAction;
